import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React from "react";
import { mixClass } from "class-lib";
import SemanticUI from "../molecules/SemanticUI";

var Image = function Image(props) {
  var imgProps = props.imgProps,
      otherProps = _objectWithoutProperties(props, ["imgProps"]);

  var classes = mixClass(props.className, {
    image: props.ui
  });
  var thisAlt = props.alt || props.title;

  if (props.atom && "img" !== props.atom) {
    return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, otherProps, {
      className: classes
    }), /*#__PURE__*/React.createElement(SemanticUI, _extends({
      atom: "img",
      src: props.src,
      alt: thisAlt
    }, imgProps)), props.children);
  } else {
    return /*#__PURE__*/React.createElement(SemanticUI, _extends({
      atom: "img"
    }, _objectSpread(_objectSpread({}, otherProps), imgProps), {
      alt: thisAlt,
      className: classes
    }));
  }
};

Image.defaultProps = {
  ui: true,
  imgProps: {
    loading: "lazy"
  }
};
export default Image;